import { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'How It Works', to: 'how-it-works' },
    { label: 'Results', to: 'results' },
    { label: 'Strategy Call', to: 'offer' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <a href="/" className="flex items-center gap-2">
          <span className={`text-lg font-extrabold tracking-tight transition-colors duration-300 ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            Direct Systems
          </span>
          <span className={`text-lg font-extrabold tracking-tight transition-colors duration-300 text-orange-500`}>
            Marketing
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              smooth
              duration={500}
              offset={-80}
              className={`text-sm font-medium cursor-pointer transition-colors ${
                scrolled ? 'text-gray-600 hover:text-gray-900' : 'text-white/90 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="form"
            smooth
            duration={500}
            offset={-80}
            className="whitespace-nowrap cursor-pointer px-5 py-2 rounded-md text-sm font-semibold border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white transition-all"
          >
            Book a Strategy Call
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-800' : 'text-white'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              smooth
              duration={500}
              offset={-80}
              className="text-gray-700 font-medium cursor-pointer"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="form"
            smooth
            duration={500}
            offset={-80}
            className="whitespace-nowrap cursor-pointer px-5 py-2 rounded-md text-sm font-semibold bg-orange-500 text-white text-center"
            onClick={() => setMenuOpen(false)}
          >
            Book a Strategy Call
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
